import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiRequest } from '../../utils/api';

const initialState = {
    data: null,
    isLoading: true,
    error: null
};

export const fetchVendorData = createAsyncThunk('data/fetchVendorData', async () => {
    try {
        const response = await apiRequest('get', 'vendors');
        return response;
    } catch (error) {
        throw error?.response?.data?.message || error?.response?.data || error?.message;
    }
});

const vendorSlice = createSlice({
    name: 'vendor',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchVendorData.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchVendorData.fulfilled, (state, action) => {
                state.isLoading = false;
                state.error = null;
                state.data = action.payload?.data;
            })
            .addCase(fetchVendorData.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error;
            });
    }
});

export default vendorSlice.reducer;
